import React, { Component } from "react";
import moment from "moment";
import {
  PATHS,
  SuiteHeaders,
  ErrorMessages,
  SuiteDummyData,
} from "../../common/constants";
import Actions from "../Actions";
import Button from "../Button";
import Empty from "../Empty";
import Icon from "../Icon";
import Overlay from "../Overlay";
import SuiteForm from "../SuiteForm";
import PropertyWalkThroughForm from "../PropertyWalkThroughForm";
import Table from "../Table";
import Search from "../Search";
import {
  setSuiteFormData,
  clearSuiteFormData,
} from "../../store/actions/suiteForm";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectSearch } from "../../store/selectors/search";
import { onEventScheduled } from "../../store/actions/contacts";
import {
  selectAuthenticatedUser,
  selectpropertyManagerDetails,
} from "../../store/selectors/auth";
import {
  setPropertyWalkThroughFormIsVisible,
  setPropertyWalkThroughFormData,
  setPropertyWalkThroughFormStep,
  fetchConfigureTypeWalkThroughData,
} from "../../store/actions/propertyWalkThroughForm";
import { selectPropertyWalkThroughFormIsVisible } from "../../store/selectors/propertyWalkThroughForm";
import {
  setEasyWalkThroughFormData,
  exitEasyWalkThroughForm,
} from "../../store/actions/easyWalkThroughForm";
import { exitPropertyWalkThroughForm } from "../../store/actions/propertyWalkThroughForm";
import { fetchAreasAndSubAreas } from "../../store/actions/areas";
import { fetchAssetsBySuiteId } from "../../store/actions/assets";
import Loader from "../Loader";
import { selectFormLoader } from "../../store/selectors/FormLoader";
import Keyhandoff from "../../pages/Suite/Keyhandoff";
import { variables } from "../../Tenants";
import {
  onSubmitKeyhandOffProcess,
  onFetchSuiteDetails,
} from "../../store/actions/suites";
import {
  checkSparkDataAvailable,
  ToastInfo,
  serviceRequestTableLocalTime,
} from "../../helpers/validationHelper";
import { startFormLoading, stopFormLoading } from "../../store/actions/loader";
import * as client from "../../services/client";
import { withRouter } from "react-router";
import { CSVLink } from "react-csv";
import CSVUpload from "../CSVUpload/CSVUpload";
import ResponsePopup from "./ResponsePopup";
import { selectValidation } from "../../store/selectors/Validation";
import { clearValidation } from "../../store/actions/validation";
import { onClearResponseDone } from "../../store/actions/suites";
import { NextAppointment } from "./cells/NextAppointment";
import { MobileDownloadIcon } from "./components/mobileDownloadIcon";

class SuitesTable extends Component {
  state = {
    showOverlay: false,
    showOverlayKeyHandoff: false,
    activatedOptions: ["Guided Walk Through", "Self-Guided Walk Through"],
    suiteData: {},
  };

  activate(e, data) {
    const { user, setWalkThroughStatus } = this.props;
    let status = {
      WalkthroughId: data.walkthroughId,
      SuiteId: data.id,
      UserId: user.id,
      Role: user.roles[0].role.name,
      Signature: "",
      Status: e.target.value,
      homeownerId: data.homeownerId,
      ActionUrl:
        e.target.value === "Guided Walk Through"
          ? "app/properties/" + this.props.property.id + "/openCalendly"
          : "app/properties/" + this.props.property.id,
    };
    let suiteData = data;

    suiteData = { ...data, status: e.target.value };

    setWalkThroughStatus(status, suiteData);
  }

  fetchSuiteById(id, action) {
    this.props.startFormLoading();
    client
      .getPropertySuiteById(id)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            this.props.stopFormLoading();
            if (action === "edit") {
              this.props.onSetSuiteFormData(responsejson);
              this.props.onSetSuiteFormData({ old: true });
              this.setState({ showOverlay: true });
            } else if (action === "key") {
              this.props.onSetSuiteFormData(responsejson);
              this.props.onSetSuiteFormData({ old: true });
              this.setState({ showOverlayKeyHandoff: true });
            } else {
              this.props.history.push({
                pathname: PATHS.SUITES_VIEW.replace(
                  ":id",
                  this.props.property.id + "&" + id
                ),
                state: { suite: responsejson, property: this.props.property },
              });
            }
          });
        } else {
          this.props.stopFormLoading();
        }
      })
      .catch((e) => this.props.stopFormLoading());
  }

  fetchSuiteDataFromCSV = (result) => {
    const { onSaveBulkImport } = this.props;
    let updatedResult = [];
    if (result && result.length > 0) {
      result = result.filter(
        (obj) =>
          Object.keys(obj).includes("Number") &&
          Object.keys(obj).includes("Rooms")
      );
      if (result && result.length > 0) {
        let findEmptyData = result.filter(
          (item) =>
            !item.Number ||
            !item.Status?.trim() ||
            !item.Rooms?.trim() ||
            !item.WarrantyDefaultStartDate?.trim()
        );
        if (findEmptyData && findEmptyData.length === 0) {
          result.map((item) => {
            const index = updatedResult.findIndex(
              (obj) => obj.Number === item.Number
            );
            let assetsArray = [];
            if (item.Assets && item.Assets.length > 0) {
              assetsArray = item.Assets.split("#");
              assetsArray = assetsArray.filter(function (el) {
                return el.trim() != "";
              });
              assetsArray = assetsArray.map((asset) => {
                return { name: asset };
              });
            }
            if (index === -1) {
              item = {
                ...item,
                areas: [{ name: item.Rooms, assets: assetsArray }],
                WarrantyDefaultStartDate: item.WarrantyDefaultStartDate
                  ? new Date(
                      moment(item.WarrantyDefaultStartDate).format("l LT")
                    )
                  : null,
              };
              updatedResult = [...updatedResult, item];
            } else {
              updatedResult = updatedResult.map((obj, j) => {
                if (obj.Number === item.Number) {
                  let filterArea = obj.areas.filter(
                    (area) => area.name === item.Rooms
                  )[0];
                  if (filterArea && filterArea.name) {
                    let areas = obj.areas.map((area) => {
                      if (area.name === item.Rooms) {
                        let uniqueIds = [];
                        let assets = [...area.assets, ...assetsArray];
                        const uniqueAssets = assets.filter((element) => {
                          const isDuplicate = uniqueIds.includes(element.name);
                          if (!isDuplicate) {
                            uniqueIds.push(element.name);
                            return true;
                          }
                          return false;
                        });

                        return { ...area, assets: uniqueAssets };
                      } else {
                        return area;
                      }
                    });
                    return { ...obj, areas: areas };
                  } else {
                    return {
                      ...obj,
                      areas: [
                        ...obj.areas,
                        { name: item.Rooms, assets: assetsArray },
                      ],
                    };
                  }
                } else {
                  return obj;
                }
              });
            }
          });
          updatedResult = updatedResult.map(
            ({ Rooms, Assets, ...rest }) => rest
          );
          onSaveBulkImport(updatedResult);
        } else {
          ToastInfo(ErrorMessages.noDatacsv);
        }
      } else {
        ToastInfo(ErrorMessages.csvValidation);
      }
    } else {
      ToastInfo(ErrorMessages.noDatacsv);
    }
  };
  /*
      Modified By: Sai Prasad
      Modified Date: 01/09/2022
      Jira Ticket: JUN-3152
      Description: function to clear response and validation .
  */
  clearSuitesImportResponse = () => {
    const { onClearValidation, onClearResponse } = this.props;
    onClearValidation();
    onClearResponse();
  };
  render() {
    const {
      suites,
      onSaveSuite,
      onSearch,
      onClearSuiteFormData,
      search,
      user,
      propertyWalkThroughFormIsVisible,
      property,
      loader,
      suitesResponse,
      validation,
    } = this.props;
    const { showOverlay, showOverlayKeyHandoff } = this.state;
    let filteredSuites = suites;
    if (this.props.user.roles[0].role.name === "Home Owner") {
      filteredSuites = filteredSuites.filter(
        (suite) => suite.homeownerId === this.props.user.id
      );
    }
    return (
      <>
        {loader ? <Loader center={true} /> : null}
        <Actions compact>
          <div className="searchbar serviceRequestsSearch">
            <Search
              size="small"
              placeholder={"Search " + variables.suiteName + "..."}
              onChange={onSearch}
            />
            {checkSparkDataAvailable(
              property,
              this.props.user.roles[0].role.name
            ) ||
            this.props.user.roles[0].role.name === "Home Owner" ||
            this.props.user.roles[0].role.name === "Occupant" ||
            user.roles[0].role.name === "Strata Manager" ? null : (
              <>
                {/*
              Modified By: Sai Prasad
              Modified Date: 26/08/2022
              Jira Ticket: JUN-2692
              Description: To download the csv suite headers template.
          */}
                <div
                  className="button-right"
                  style={{ paddingTop: 7 }}
                  title="Download CSV template"
                >
                  <CSVLink
                    data={SuiteDummyData}
                    headers={SuiteHeaders}
                    filename={`${variables.suiteName}.csv`}
                    ref={this.csvLink}
                    target="_blank"
                  >
                    <Icon glyph="download" weight="regular" size="big" />
                  </CSVLink>
                </div>
                <div className="button-right">
                  <CSVUpload
                    onFetchData={this.fetchSuiteDataFromCSV}
                    buttonName="Bulk Suites Import"
                  />
                </div>
                <div className="button-right">
                  <Button
                    color="teal"
                    label={"Add " + variables.Suite}
                    onClick={() => {
                      this.props.onSetSuiteFormData({
                        new: true,
                        propertyId: property.id,
                        old: false,
                      });
                      this.setState({ showOverlay: true });
                    }}
                    icon={<Icon glyph="home" weight="light" size="small" />}
                    size="small"
                  />
                </div>
              </>
            )}
          </div>
        </Actions>
        {filteredSuites.length > 0 ? (
          <>
            <Table
              defaultSort={{
                accessor: "number",
                direction: "descending",
              }}
              columns={[
                {
                  label: "",
                  accessor: "mobileSyncAllowed",
                  xsHide: true,
                  style: { width: "1rem" },
                  cell: (data) => <MobileDownloadIcon property={data} />,
                },
                {
                  label: variables.Suite,
                  sortable: true,
                  accessor: "number",
                  cell: (data) => (
                    <div
                      onClick={() => this.fetchSuiteById(data.id, "view")}
                      style={{ cursor: "pointer" }}
                    >
                      {data && data.number}
                    </div>
                  ),
                },
                {
                  center: true,
                  xsHide: true,
                  label: variables.serviceRequest + "s",
                  accessor: "serviceRequests",
                  cell: (data) => (
                    <div
                      title={`Walk-through: ${data.walkthroughServiceRequestsCount}, Other: ${data.normalServiceRequestsCount}`}
                    >
                      {data.serviceRequests}
                    </div>
                  ),
                },
                {
                  label: variables.homeOwner,
                  cell: (data) =>
                    data.homeOwners && data.homeOwners.id ? (
                      <>
                        {data.homeOwners.firstname +
                          " " +
                          data.homeOwners.lastname}
                      </>
                    ) : null,
                },
                {
                  center: true,
                  xsHide: true,
                  label: "Status",
                  accessor: "status",
                },
                {
                  center: true,
                  xsHide: true,
                  label: "Warranty Start Date",
                  cell: (data) =>
                    data.warrantyStartDate ? (
                      <>
                        {serviceRequestTableLocalTime(
                          data.warrantyStartDate
                        ) === "01/01/0001"
                          ? ""
                          : serviceRequestTableLocalTime(
                              data.warrantyStartDate
                            )}
                      </>
                    ) : null,
                },
                {
                  center: false,
                  xsHide: true,
                  label: "Appointment",
                  sortable: true,
                  accessor: "nextAppointment",
                  sortingAlgorithm: (a, b) => {
                    if (a === null) return 1;
                    if (b === null) return -1;
                    try {
                      const parsedJsonA = JSON.parse(a);
                      const parsedJsonB = JSON.parse(b);
                      return moment(parsedJsonA?.timeStamp).diff(
                        parsedJsonB?.timeStamp
                      );
                    } catch {
                      return 0;
                    }
                  },
                  cell: (data) => (
                    <NextAppointment nextAppointment={data.nextAppointment} />
                  ),
                },
                
              ]}
              data={filteredSuites}
            />
          </>
        ) : (
          <Empty
            headline={"No " + variables.suites + " yet"}
            strapline={
              "All " +
              variables.suites +
              " you add will be listed here so it’s easier for you to manage."
            }
            searchIsActive={search && search.suites ? search.suites : ""}
            cta={
              checkSparkDataAvailable(
                property,
                this.props.user.roles[0].role.name
              ) ||
              this.props.user.roles[0].role.name === "Home Owner" ||
              this.props.user.roles[0].role.name === "Occupant" ||
              user.roles[0].role.name === "Strata Manager" ? null : (
                <Button
                  color="teal"
                  onClick={() => {
                    this.props.onSetSuiteFormData({
                      new: true,
                      propertyId: property.id,
                      old: false,
                    });
                    this.setState({ showOverlay: true });
                  }}
                  icon={<Icon glyph="home" weight="light" size="small" />}
                  label={"Add " + variables.Suite}
                  size="small"
                />
              )
            }
            image={
              <img
                alt={"No " + variables.suites + " yet"}
                src="/assets/empty/suites.svg"
              />
            }
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <SuiteForm
              onClose={() => {
                this.setState({ showOverlay: false }, () =>
                  onClearSuiteFormData()
                );
              }}
              onSaveSuite={onSaveSuite}
            />
          }
        />
        <Overlay
          showOverlay={propertyWalkThroughFormIsVisible}
          content={<PropertyWalkThroughForm onSaveSuite={onSaveSuite} />}
        />
        <Overlay
          showOverlay={showOverlayKeyHandoff}
          content={
            <Keyhandoff
              onSubmitKeyhandOffProcess={this.props.onSubmitKeyhandOffProcess}
              onClose={() => {
                this.setState({ showOverlayKeyHandoff: false }, () =>
                  onClearSuiteFormData()
                );
              }}
            />
          }
        />
        {/*
          Created By: Sai Prasad
          Created Date: 26/08/2022
          Jira Ticket: JUN-3152
          Description: imported ResponsePopup component to show response to user.
        */}
        {validation.status === true &&
          validation.message === "Suites Imported" &&
          suitesResponse.length > 0 && (
            <ResponsePopup
              data={suitesResponse}
              onPress={this.clearSuitesImportResponse}
            />
          )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  search: selectSearch(state),
  user: selectAuthenticatedUser(state),
  propertyManagerDetails: selectpropertyManagerDetails(state),
  propertyWalkThroughFormIsVisible:
    selectPropertyWalkThroughFormIsVisible(state),
  loader: selectFormLoader(state),
  buildings: state.buildings,
  validation: selectValidation(state),
  suitesResponse: state.responseStore.suitesImport,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetSuiteFormData: setSuiteFormData,
      onClearSuiteFormData: clearSuiteFormData,
      onSetPropertyWalkThroughFormIsVisible:
        setPropertyWalkThroughFormIsVisible,
      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
      onSetPropertyWalkThroughFormStep: setPropertyWalkThroughFormStep,
      onFetchConfigureTypeWalkThroughData: fetchConfigureTypeWalkThroughData,
      onExitEasyWalkThroughForm: exitEasyWalkThroughForm,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
      onfetchAssetsBySuiteId: fetchAssetsBySuiteId,
      onEventScheduled,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      onSubmitKeyhandOffProcess: onSubmitKeyhandOffProcess,
      onFetchSuiteDetails: onFetchSuiteDetails,
      startFormLoading,
      stopFormLoading,
      onClearValidation: clearValidation,
      onClearResponse: onClearResponseDone,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SuitesTable)
);
